var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplore6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 376,
    viewBox: "0 0 358 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1117_34408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.996 226.386L312.827 164.732",
    stroke: "url(#paint0_linear_1117_34408)",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.936 209.02L173.316 366.186",
    stroke: "url(#paint1_linear_1117_34408)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.457 299.984L168.755 463.214",
    stroke: "url(#paint2_linear_1117_34408)",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.107 295.788L186.923 420.611",
    stroke: "url(#paint3_linear_1117_34408)",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.055 325.402L288.939 222.814",
    stroke: "url(#paint4_linear_1117_34408)",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.109 369.422L358.47 231.459",
    stroke: "url(#paint5_linear_1117_34408)",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.816 268.146L393.275 160",
    stroke: "url(#paint6_linear_1117_34408)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.152 363.659L290.391 457.15",
    stroke: "url(#paint7_linear_1117_34408)",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.414 205.482L279.748 291.898",
    stroke: "url(#paint8_linear_1117_34408)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.961 322.22L211.834 479.891",
    stroke: "url(#paint9_linear_1117_34408)",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.452 161.011L275.186 291.898",
    stroke: "url(#paint10_linear_1117_34408)",
    strokeWidth: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1117_34408",
    x1: 250.996,
    y1: 226.386,
    x2: 312.649,
    y2: 164.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397DC7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1117_34408",
    x1: 173.316,
    y1: 366.186,
    x2: 330.481,
    y2: 208.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D891B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D891B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1117_34408",
    x1: 168.755,
    y1: 463.214,
    x2: 331.984,
    y2: 299.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D891B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D891B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1117_34408",
    x1: 186.923,
    y1: 420.611,
    x2: 311.746,
    y2: 295.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397DC7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1117_34408",
    x1: 186.055,
    y1: 325.402,
    x2: 288.642,
    y2: 222.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397DC7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1117_34408",
    x1: 358.47,
    y1: 231.459,
    x2: 220.508,
    y2: 369.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D891B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D891B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1117_34408",
    x1: 284.816,
    y1: 268.146,
    x2: 392.962,
    y2: 159.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D891B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D891B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1117_34408",
    x1: 290.391,
    y1: 457.15,
    x2: 383.882,
    y2: 363.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397DC7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1117_34408",
    x1: 279.748,
    y1: 291.898,
    x2: 366.164,
    y2: 205.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D891B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D891B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1117_34408",
    x1: 369.961,
    y1: 322.22,
    x2: 212.29,
    y2: 480.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397DC7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1117_34408",
    x1: 406.452,
    y1: 161.011,
    x2: 275.565,
    y2: 292.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D891B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D891B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1117_34408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 376,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore6);
export default __webpack_public_path__ + "static/media/explore6.d820796c6233d6fd068004c49905dda6.svg";
export { ForwardRef as ReactComponent };